import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

function SidebarLayoutSection({ children, css, ...others }) {
  const theme = useTheme();

  return (
    <Box
      component="ul"
      m={0}
      p={0}
      sx={{
        listStyle: 'none',
        '& > :not(:first-child)': {
          marginTop: theme.spacing(3),
        },
        ...css,
      }}
      {...others}
    >
      {children}
    </Box>
  );
}

SidebarLayoutSection.propTypes = {
  children: PropTypes.node,
  css: PropTypes.object,
};

export default SidebarLayoutSection;
